import React, { useState } from 'react';
import { Box, SelectComponent, LoadingSpinner } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { useGetMassUploadHistoryQuery } from '@epi-api/massUploadHistory/massUploadHistoryApi';
import { Pagination } from '@epi-shared/components';
import {
  IMassUploadHistoryItemWithNumericStatus,
  MassUploadStatus,
  mapMassUploadStatusToNumber
} from '@epi-models/pages/MassUpload';

import { MassUploadItemsTable } from './components/MassUploadItemsTable';

export const MassUpload = () => {
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState<
    MassUploadStatus | undefined
  >(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const options = [
    {
      display: t('containers.mass_upload.history_status.1'),
      id: MassUploadStatus.Created
    },
    {
      display: t('containers.mass_upload.history_status.2'),
      id: MassUploadStatus.InProgress
    },
    {
      display: t('containers.mass_upload.history_status.3'),
      id: MassUploadStatus.Closed
    },
    {
      display: t('containers.mass_upload.history_status.4'),
      id: MassUploadStatus.ClosedWithFailures
    }
  ];

  const handleChange = value => {
    setSelectedStatus(value.id);
    setCurrentPage(1);
  };

  const {
    data: historyData,
    isLoading,
    isError
  } = useGetMassUploadHistoryQuery({
    page: currentPage,
    pageSize,
    status: selectedStatus
  });

  const sourceItems = historyData?.items ?? [];
  const items: IMassUploadHistoryItemWithNumericStatus[] = sourceItems.map(
    item => ({
      ...item,
      status: mapMassUploadStatusToNumber(item.status)
    })
  );
  const totalCount = historyData?.totalCount ?? 0;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Box p={4}>{t('containers.mass_upload.history.error')}</Box>;
  }

  return (
    <Box marginTop="40px">
      <Box mt={3}>
        <Box ml={-1} zIndex={0} position={'relative'}>
          <SelectComponent
            label=""
            placeholder={t('containers.mass_upload.select.title')}
            id="hr-import-history-filter-select"
            selectedId={selectedStatus}
            options={options}
            onChange={handleChange}
          />
        </Box>
      </Box>

      {items.length > 0 && (
        <Box pt={5}>
          <MassUploadItemsTable items={items} />

          {totalCount > 0 && (
            <Box mt={3} display="flex" justifyContent="center">
              <Pagination
                page={currentPage}
                count={Math.ceil(totalCount / pageSize)}
                defaultRowsPerPage={pageSize}
                onChangePage={(pageNumber: number) => {
                  setCurrentPage(pageNumber);
                  window.scrollTo(0, 0);
                }}
              />
            </Box>
          )}
        </Box>
      )}

      {items.length === 0 && (
        <Box pt={20} display="flex" justifyContent="center">
          {t('containers.mass_upload.history.no_data')}
        </Box>
      )}
    </Box>
  );
};
